import { ref, computed, inject, provide } from "vue";

// Admin layout context key
export const ADMIN_LAYOUT_KEY = Symbol("adminLayout");

/**
 * Composable for providing admin layout context
 * Should be used in AdminLayout.vue
 */
export function provideAdminLayout(topSectionHeight = ref("40px")) {
  const adminLayoutContext = {
    topSectionHeight: computed(() => topSectionHeight.value),
    sidebarWidth: "250px",
    isAdminLayout: true,
  };

  provide(ADMIN_LAYOUT_KEY, adminLayoutContext);

  return adminLayoutContext;
}

/**
 * Composable for consuming admin layout context
 * Can be used in any component within AdminLayout
 */
export function useAdminLayout() {
  const context = inject(ADMIN_LAYOUT_KEY, null);

  return {
    topSectionHeight: context?.topSectionHeight || ref("40px"),
    sidebarWidth: context?.sidebarWidth || "250px",
    isAdminLayout: context?.isAdminLayout || false,
  };
}

/**
 * Composable specifically for loading overlay in admin context
 */
export function useAdminLoadingOverlay() {
  const { topSectionHeight, isAdminLayout } = useAdminLayout();

  return {
    loadingOverlayProps: computed(() => ({
      teleportToBody: true,
      adminLayout: isAdminLayout,
      topSectionHeight: topSectionHeight.value,
    })),
  };
}
